import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesFileService } from '../services/sales-file.service';
import { HttpEventType } from '@angular/common/http';
import { AppConfigService } from '../../app.config';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { ModalDirective } from 'ngx-bootstrap';
import { SalesFileType } from '../../enums/salesFileType';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { PlanStatus } from '../../plan/enums/plan-status.enum';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'crm-user-target',
  templateUrl: './user-target.component.html',
  styleUrls: ['./user-target.component.css']
})
export class UserTargetComponent implements OnInit {
  columns: any[] = [];
  progress: number;
  message: string;
  error: boolean = false;
  fileTypes: any[] = [{ name: "Hco" }, { name: "Pharmacy" }];
  fileType: any;
  selectedDate: any;
  files: any[] = [];
  filesData: any[] = [];
  pageSize: number = this.appConfig.settings.pageSize;
  public logo = require("../../../app/assets/images/demo/Icon_Sales.png");
  salesType: SalesFileType = SalesFileType.userTarget;
  selectedFileId;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  reviewMode = false;
  viewOnly = false;

  constructor(private translateService: AppTranslationService, private alertService: AlertService,
    private accountService: AccountService, private readonly route: ActivatedRoute,
    private readonly appConfig: AppConfigService, private salesFileService: SalesFileService) { }


  ngOnInit() {
    this.getUserTargetFilesData();
    this.fileType = this.fileTypes.find(x => x.name == "Hco");
    this.columns = [

      { field: 'name', header: 'Name' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'createdBy', header: 'Created By Name' },
      { field: 'insertDate', header: 'Insert Date' },
      { field: 'creationDate', header: 'Creation Date' },
      { field: 'status', header: 'Status' }
    ];

    this.route.params.subscribe(params => {
      if (params["fileid"] && params["review"])
        this.reveiw(params["fileid"])
      else if (params["fileid"])
        this.view(params["fileid"])
    });

  }

  getUserTargetFilesData() {
    this.salesFileService.getUserTargetFilesData().subscribe(response => {
      let result = response as any[];
      this.filesData = result;
    }, err => {
      console.log(err);
    });
  }

  downloadCSVTemplate() {
    if (!this.selectedDate || this.message == 'loading' || !this.fileType)
      return;

    this.salesFileService.downloadCsvTemplate(9).subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "UserTarget.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);

    },
      err => { console.log(err); });
  }

  uploadFile() {
    if (!this.selectedDate || this.message == 'loading')
      return;
    document.getElementById('choosefile').click();
  }


  confirmDelete(itemId) {
    this.selectedFileId = itemId;
    this.deleteModal.show();

  }

  delete() {
    this.hideDeleteModal();
    this.salesFileService.delete(this.selectedFileId).subscribe(response => {
      if (response == false) {
        this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      }
      else {
        this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Success);
        this.getUserTargetFilesData();
      }

    }, err => {

      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }

  upload(files) {
    if (files.length === 0 || !this.fileType)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);
    this.message = 'loading';

    this.salesFileService.provision(formData, 9, this.selectedDate, false, this.fileType.name == "Hco").subscribe(event => {
      if (event.type === HttpEventType.UploadProgress)
        this.progress = Math.round(100 * event.loaded / event.total);
      else if (event.type === HttpEventType.Response) {
        if (event && event.body) {
          let res = event.body as any;
          if (res && res.isError) {
            this.error = true;
            this.message = "uploaded with error";
            this.downloadCSVTemplatErrorFile();
          } else {
            this.message = "uploaded success";
          }
        } else {
          this.message = "uploaded success";
        }

        
        this.getUserTargetFilesData();
      }
    });

  }

  downloadCSVTemplatErrorFile() {
    this.salesFileService.downloadUserTargetErrorFile().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "Error.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
    },
      err => {
        console.log(err);
      });
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  reveiw(id) {
    this.selectedFileId = id;

    this.reviewMode = true;
  }

  view(id) {
    this.selectedFileId = id;
    this.viewOnly = true;
    this.reviewMode = true;
  }

  closeReviewMode(event) {
    this.selectedFileId = undefined;
    this.reviewMode = false;
    this.viewOnly = false;
    if (event) {
      this.getUserTargetFilesData();
    }
  }

  get canDeleteFile() {
    return this.accountService.userHasPermission(Permission.deleteUserTargetRequest);
  }
  
  getStatusName(status: number): string {
    return PlanStatus[status];
  }



}
